import React from "react";

export default function Screen(props) {
  return <div className="screen">{props.value}</div>;
}
